// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var card = BsCssJs$PrezzeeRibbon.merge([
      Theme__Typography$PrezzeeRibbon.Styles.body,
      BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(30))])
    ]);

var photo = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.objectFit("contain"),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.display("block")
          ])
    ]);

var photoFront = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector("img", [BsCssJs$PrezzeeRibbon.height("auto")])]);

var hoverEffect = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.zIndex(2),
      BsCssJs$PrezzeeRibbon.opacity(1),
      BsCssJs$PrezzeeRibbon.selector("&:hover", [BsCssJs$PrezzeeRibbon.opacity(0)])
    ]);

var photoBack = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.zIndex(1),
      BsCssJs$PrezzeeRibbon.left("zero"),
      BsCssJs$PrezzeeRibbon.top("zero"),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.selector("img", [BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))])
    ]);

var text = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(22))]);

var name = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.primaryRed),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.25)),
            BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.rem(1.75)),
            BsCssJs$PrezzeeRibbon.fontWeight("light"),
            BsCssJs$PrezzeeRibbon.margin("zero"),
            BsCssJs$PrezzeeRibbon.textDecoration("none")
          ])
    ]);

var title = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.charcoal),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.25)),
            BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.rem(1.75)),
            BsCssJs$PrezzeeRibbon.fontWeight("semiBold"),
            BsCssJs$PrezzeeRibbon.margin("zero"),
            BsCssJs$PrezzeeRibbon.textDecoration("none")
          ])
    ]);

var description = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.midGrey),
      BsCssJs$PrezzeeRibbon.selector("p", [
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(6)),
            BsCssJs$PrezzeeRibbon.marginBottom("zero")
          ])
    ]);

var Styles = {
  card: card,
  photo: photo,
  photoFront: photoFront,
  hoverEffect: hoverEffect,
  photoBack: photoBack,
  text: text,
  name: name,
  title: title,
  description: description
};

function TeamMemberCard$Photos(props) {
  var photoBack$1 = props.photoBack;
  var hoverPhoto = Belt_Option.mapWithDefault(photoBack$1, null, (function (pb) {
          return JsxRuntime.jsx("div", {
                      children: pb,
                      className: photoBack
                    });
        }));
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.photoFront,
                      className: Classnames([
                            photoFront,
                            Belt_Option.isSome(photoBack$1) ? hoverEffect : ""
                          ])
                    }),
                hoverPhoto
              ],
              className: photo
            });
}

var Photos = {
  make: TeamMemberCard$Photos
};

function TeamMemberCard(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(TeamMemberCard$Photos, {
                      photoFront: props.photoFront,
                      photoBack: props.photoBack
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: props.name,
                              className: name
                            }),
                        JsxRuntime.jsx("div", {
                              children: props.title,
                              className: title
                            }),
                        JsxRuntime.jsx("div", {
                              children: props.description,
                              className: description
                            })
                      ],
                      className: text
                    })
              ],
              className: card
            });
}

var make = TeamMemberCard;

export {
  Styles ,
  Photos ,
  make ,
}
/* card Not a pure module */
